import { Link } from "react-router-dom";
import React from "react";

interface NavBoxProps {
  title: string;
  description: string;
  link: string;
  linkText: string;
  icon: React.ReactNode;
}

const NavBox = ({ title, description, link, linkText, icon }: NavBoxProps) => {
  return <div className="bg-white shadow-md rounded-lg p-4 hover:bg-gray-50 transition-colors h-40 flex flex-col">
    <div className="flex justify-between items-center">
      <h2 className="text-lg font-medium text-gray-800">{title}</h2>
      <div className="p-1.5 bg-primary-100 rounded-lg">
        <div className="w-4 h-4 text-primary-600">
          {icon}
        </div>
      </div>
    </div>
    <p className="text-gray-600 mt-1.5 text-sm">{description}</p>
    <div className="mt-auto">
      <button className="inline-block px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors text-sm">
        <Link
          to={link}
        >
          {linkText}
        </Link>
      </button>
    </div>
  </div>;
};

export default NavBox;


